@if (input.multiple) {
  <!-- Material dropdown with  multiple select -->
  @if (isLarge$ | async) {
    <mat-form-field
      [appearance]="input.appearance"
      [subscriptSizing]="input.subscriptSizing"
      [floatLabel]="'always'"
    >
      @if (input.label | parse: context | async; as label) {
        <mat-label>{{ label }}</mat-label>
      }
      <mat-select
        [formControl]="_formControl"
        [placeholder]="(input.placeholder | parse: context | async) ?? (noneSelected() ? 'All' : null)"
        [required]="input.required"
        (blur)="onBlur($event)"
        multiple
      >
        @if (input.multiple && (allChecked() || noneSelected())) {
          <mat-select-trigger> All </mat-select-trigger>
        }
        <button
          class="mat-mdc-option mdc-list-item mat-mdc-option-multiple full-width"
          matRipple
          (click)="toggleAllSelection()"
        >
          <mat-pseudo-checkbox
            [state]="allChecked() ? 'checked' : 'unchecked'"
          />
          <span class="mdc-list-item__primary-text">All</span>
        </button>
        @for (
          option of parsedOptions();
          track option[input.optionsValueKey || 'value']
        ) {
          <mat-option
            [value]="option[input.optionsValueKey || 'value']"
            [disabled]="option.disabled"
          >
            @if (input?.optionWidget; as optionWidget) {
              <ng-container [dynamicWidget]="optionWidget" [context]="option" />
            } @else {
              {{
                option[input.optionsLabelKey || 'label']
                  | parse: context
                  | async
              }}
            }
          </mat-option>
        }
      </mat-select>
      @if (firstFormControlError; as error) {
        <mat-error>
          {{ error.errorMessage }}
        </mat-error>
      }
    </mat-form-field>
  } @else {
    <!-- Native dropdown with multiple select -->
    <mat-form-field
      [appearance]="input.appearance"
      [subscriptSizing]="input.subscriptSizing"
    >
      <select
        matNativeControl
        [formControl]="_formControl"
        [placeholder]="input.placeholder | parse: context | async"
        [required]="input.required"
        (blur)="onBlur($event)"
        multiple
      >
        @for (
          option of parsedOptions$ | async;
          track option[input.optionsValueKey || 'value']
        ) {
          <option
            [ngValue]="option[input.optionsValueKey || 'value']"
            [disabled]="option.disabled"
          >
            @if (input?.optionWidget; as optionWidget) {
              <ng-container
                [dynamicWidget]="optionWidget"
                [context]="option"
              ></ng-container>
            } @else {
              {{
                option[input.optionsLabelKey || 'label']
                  | parse: context
                  | async
              }}
            }
          </option>
        }
      </select>
      @if (firstFormControlError; as error) {
        <mat-error>
          {{ error.errorMessage }}
        </mat-error>
      }
    </mat-form-field>
  }
} @else {
  <!-- material select dropdown -->
  @if (isLarge$ | async) {
    <mat-form-field
      [appearance]="input.appearance"
      [subscriptSizing]="input.subscriptSizing"
    >
      @if (input.label | parse: context | async; as label) {
        <mat-label>{{ label }}</mat-label>
      }
      <mat-select
        [formControl]="_formControl"
        [placeholder]="input.placeholder | parse: context | async"
        [required]="input.required"
        (blur)="onBlur($event)"
      >
        @for (
          option of parsedOptions$ | async;
          track option[input.optionsValueKey || 'value']
        ) {
          <mat-option
            (click)="
              updateLabelByValue(option[input.optionsValueKey || 'value'])
            "
            [value]="option[input.optionsValueKey || 'value']"
            [disabled]="option.disabled"
          >
            @if (input?.optionWidget; as optionWidget) {
              <ng-container [dynamicWidget]="optionWidget" [context]="option" />
            } @else {
              {{
                option[input.optionsLabelKey || 'label']
                  | parse: context
                  | async
              }}
            }
          </mat-option>
        }
      </mat-select>
      @if (firstFormControlError; as error) {
        <mat-error>
          {{ error.errorMessage }}
        </mat-error>
      }
    </mat-form-field>
  } @else {
    <!-- Native select dropdown -->
    <mat-form-field
      [appearance]="input.appearance"
      [subscriptSizing]="input.subscriptSizing"
    >
      @if (input.label | parse: context | async; as label) {
        <mat-label>{{ label }}</mat-label>
      }
      <select
        matNativeControl
        [formControl]="_formControl"
        [placeholder]="input.placeholder | parse: context | async"
        [required]="input.required"
        (blur)="onBlur($event)"
        (change)="updateLabelByValue($any($event.target).value)"
      >
        @for (
          option of parsedOptions$ | async;
          track option[input.optionsValueKey || 'value']
        ) {
          <option
            [ngValue]="option[input.optionsValueKey || 'value']"
            [disabled]="option.disabled"
          >
            @if (input?.optionWidget; as optionWidget) {
              <ng-container
                [dynamicWidget]="optionWidget"
                [context]="option"
              ></ng-container>
            } @else {
              {{
                option[input.optionsLabelKey || 'label']
                  | parse: context
                  | async
              }}
            }
          </option>
        }
      </select>
      @if (firstFormControlError; as error) {
        <mat-error>
          {{ error.errorMessage }}
        </mat-error>
      }
    </mat-form-field>
  }
}
